/**
 * Bor jellege   * DRY - száraz   * SEMI_DRY - félszáraz   * SWEET - édes   * OBLIVION - félédes   * PEARLESCENT - gyöngyöző   * OTHER - egyéb   * DESSERT - desszert
 */
export type WineSweetness =
  | 'DRY'
  | 'SEMI_DRY'
  | 'SWEET'
  | 'OBLIVION'
  | 'PEARLESCENT'
  | 'OTHER'
  | 'DESSERT';

export const WineSweetness = {
  Dry: 'DRY' as WineSweetness,
  SemiDry: 'SEMI_DRY' as WineSweetness,
  Sweet: 'SWEET' as WineSweetness,
  Oblivion: 'OBLIVION' as WineSweetness,
  Pearlescent: 'PEARLESCENT' as WineSweetness,
  Other: 'OTHER' as WineSweetness,
  Dessert: 'DESSERT' as WineSweetness,
};
